(function () {
  function initStickyAtc(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var infoSection = document.getElementById('ProductInfo-' + sectionId);
    var priceContainer = document.getElementById('price-' + sectionId);
    var stickyPriceWrap = document.getElementById('StickyATC-Price-' + sectionId);
    var stickyButton = document.getElementById('StickyATC-Button-' + sectionId);

    if (!mainButton || !stickyButton || !infoSection) return;

    // IMPORTANTE: el contenedor .product__info-wrapper puede llevar un transform
    // (clase animate--slide-in cuando las animaciones al hacer scroll estan activas).
    // Un ancestro con transform se convierte en el bloque contenedor de los hijos
    // position:fixed, lo que ancla la barra al final del contenedor en lugar de a
    // la ventana. Al mover la barra al <body> escapamos de ese contexto.
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function syncPrice() {
      if (!priceContainer || !stickyPriceWrap) return;
      var candidates = priceContainer.querySelectorAll('.price-item--sale, .price-item--regular');
      var visible = Array.prototype.filter.call(candidates, function (el) {
        return el.offsetParent !== null;
      });
      if (visible.length === 0) return;
      if (visible.length >= 2) {
        var saleEl, regEl;
        visible.forEach(function (el) {
          if (el.classList.contains('price-item--sale')) saleEl = el;
          if (el.classList.contains('price-item--regular')) regEl = el;
        });
        saleEl = saleEl || visible[1];
        regEl = regEl || visible[0];
        stickyPriceWrap.innerHTML =
          '<span>' + saleEl.textContent.trim() + '</span>' +
          '<span class="compare">' + regEl.textContent.trim() + '</span>';
      } else {
        stickyPriceWrap.innerHTML = '<span>' + visible[0].textContent.trim() + '</span>';
      }
    }

    function syncDisabled() {
      stickyButton.disabled = mainButton.disabled;
      var label = mainButton.querySelector('span');
      if (label && label.textContent.trim()) {
        stickyButton.textContent = label.textContent.trim();
      }
    }

    syncPrice();
    syncDisabled();

    if (priceContainer && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (window.MutationObserver) {
      new MutationObserver(syncDisabled).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
    }

    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled) return;
      mainButton.click();
    });

    function show() {
      bar.setAttribute('data-visible', '');
      document.body.classList.add('has-sticky-atc');
    }

    function hide() {
      bar.removeAttribute('data-visible');
      document.body.classList.remove('has-sticky-atc');
    }

    function setVisibility(entry) {
      if (isDesktop()) {
        bar.hidden = true;
        hide();
        return;
      }
      bar.hidden = false;
      if (entry.isIntersecting) {
        hide();
      } else {
        show();
      }
    }

    if (window.IntersectionObserver) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;';
      var computedPosition = window.getComputedStyle(infoSection).position;
      if (computedPosition === 'static') {
        infoSection.style.position = 'relative';
      }
      infoSection.insertBefore(sentinel, infoSection.firstChild);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(setVisibility);
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    }

    window.addEventListener('resize', function () {
      if (isDesktop()) {
        bar.hidden = true;
        hide();
      }
    });
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
})();
